export default "__VITE_ASSET__a2a83b3f__"